const fireViewEndCustomEvent = () => {
  var event=new CustomEvent('event-view-end');
  var obj = document.querySelector("body"); obj.dispatchEvent(event);
 }
 const fireViewStartCustomEvent = (data) => {
  var event=new CustomEvent('event-react-view-start', data);
  var obj = document.querySelector("body");
  obj.dispatchEvent(event);
 }
 const fireActionTriggerCustomEvent = (target, data) => {
  console.log("SDSDSDSDS");console.log(target, data);
  var event=new CustomEvent('event-action-trigger', data);
  var obj = target.dispatchEvent(event);
  
 }
 export {
  fireViewEndCustomEvent,
  fireViewStartCustomEvent,
  fireActionTriggerCustomEvent
 }